import React, { useCallback, useState } from "react";

import "./WordCard.css";

import { useDispatch, useSelector } from "react-redux";

import {
  clearGuess,
  selectNewsieCard,
} from "Store/features/public/publicPuzzleSlice";

const WordCard = (props) => {
  const dispatch = useDispatch();

  const {
    infoModal = false,
    isSelected,
    isLive,
    word,
    columnIndex,
    wordIndex,
    incorrect,
    correct,
  } = props;
  const correctGuess = useSelector(
    (state) => state.publicPuzzleSlice?.puzzle?.correctGuess
  );
  const [localWord, setWord] = useState(word);
  const [editorSelected, setEditorSelected] = useState(false);
  const handleClickCard = useCallback(() => {
    if (isLive) {
      const wordVal = !isSelected ? wordIndex : null;
      if (correctGuess) return;
      if (correct) return;
      dispatch(
        selectNewsieCard({ columnIndex, wordIndex: wordVal, fromTap: true })
      );
      dispatch(clearGuess());
    } else {
      setEditorSelected(!editorSelected);
    }
  }, [
    isLive,
    isSelected,
    wordIndex,
    columnIndex,
    correctGuess,
    correct,
    dispatch,
    word,
  ]);

  const doingNothing = !correct && !incorrect;
  const className = `word-card ${isSelected ? "selected" : ""} ${
    correctGuess === false && isSelected ? "incorrect" : ""
  } ${correctGuess && isSelected ? "correct" : ""} ${
    word.length > 8 ? "longword" : ""
  } ${word.length > 10 ? "very-longword" : ""} ${
    doingNothing ? "doing-nothing" : ""
  } ${isLive ? "" : "editor"} `;
  return (
    <div className={className} onClick={handleClickCard}>
      {!isLive && editorSelected ? (
        <input
          type="text"
          placeholder="Title"
          value={word}
          // onChange={(e) => setTitle(e.target.value)}
          onClick={(e) => e.stopPropagation()}
        />
      ) : (
        <b>{word}</b>
      )}
    </div>
  );
};

export default WordCard;
